import classnames from 'classnames';
import compact from 'lodash/compact';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Reactable from 'reactable';
import Money from '../../../common/money';
import Footer from './components/Footer';
import { extractUnassignedSales, sumReports } from './helpers';
import Hours from '../../../common/Hours';

class PayoutsProductTable extends Component {
  renderLargeSingleRow(singleReport, setBarberCommission) {
    const { Tr } = Reactable;
    const { Td } = Reactable;
    const { showGiftCards } = this.props;
    return (
      <Tr
        key={`large_${singleReport.Name}`}
        className="c-table-card__row c-table-card__row--clickable"
        data-automation-id={`dataRow:product:${singleReport.Name}`}
      >
        <Td
          column="Name"
          className="c-table-card__cell u-text-left u-pl--"
          data={singleReport.Name}
          data-automation-id="text:name"
        >
          {singleReport.Name}
        </Td>
        <Td
          column="Hours Worked"
          className="c-table-card__cell u-text-left u-pl--"
          data-automation-id="text:hoursWorked"
        >
          <Hours>{singleReport['Hours Worked']}</Hours>
        </Td>
        <Td column="Card" value={singleReport.Card} className="c-table-card__cell">
          <Money cents={singleReport.Card} automationId="text:card" />
        </Td>
        <Td column="Cash" value={singleReport.Cash} className="c-table-card__cell">
          <Money cents={singleReport.Cash} automationId="text:cash" />
        </Td>
        <Td
          className={classnames('c-table-card__cell', { 'is-hidden': !showGiftCards })}
          column="Gift Card"
          value={singleReport['Gift Card']}
        >
          <Money cents={singleReport['Gift Card']} automationId="text:giftCard" />
        </Td>
        <Td column="Total" value={singleReport.Total} className="c-table-card__cell">
          <Money cents={singleReport.Total} automationId="text:total" />
        </Td>
        <Td
          column="Commission %"
          value={singleReport.commissionPercentage}
          className="c-table-card__cell"
          data-automation-id="text:commissionPercentage"
        >
          {singleReport.commissionPercentage && `${singleReport.commissionPercentage}%`}
        </Td>
        <Td column="Due to Barbers" value={singleReport['Due to Barbers']} className="c-table-card__cell">
          <Money cents={singleReport['Due to Barbers']} automationId="text:dueToBarbers" />
        </Td>
        <Td column="Tax" value={singleReport.TaxAmount} className="c-table-card__cell">
          <Money cents={singleReport.TaxAmount} automationId="text:taxAmount" />
        </Td>
        <Td column="Due To Shop" value={singleReport['Due To Shop']} className="c-table-card__cell">
          <Money cents={singleReport['Due To Shop']} automationId="text:dueToShop" />
        </Td>
      </Tr>
    );
  }

  render() {
    const { barberReports, showGiftCards, timeTrackingEnabled } = this.props;

    const sortableLarge = compact([
      'Name',
      timeTrackingEnabled ? 'Hours Worked' : null,
      'Card',
      'Cash',
      showGiftCards ? 'Gift Card' : null,
      'Total',
      'Commission %',
      'Due to Barbers',
      'Tax',
      'Due To Shop',
    ]);

    const { Table } = Reactable;
    let report = null;
    const { sales: data, unassigned } = extractUnassignedSales(barberReports);
    if (data.length) {
      report = data.map(barberReport => this.renderLargeSingleRow(barberReport));
    }

    const total = sumReports(barberReports);
    return (
      <Table
        className="c-table-with-sticky-header c-table-new c-table--small c-table--border c-no-hover"
        id="table"
        sortable={sortableLarge}
        columns={sortableLarge}
        data-automation-id="table:products"
      >
        {report}
        {Footer({ columns: sortableLarge, total, unassigned })}
      </Table>
    );
  }
}

PayoutsProductTable.propTypes = {
  barberReports: PropTypes.array.isRequired,
  showGiftCards: PropTypes.bool.isRequired,
  timeTrackingEnabled: PropTypes.bool.isRequired,
};

export default PayoutsProductTable;
